import React, { Component } from 'react';
import central, { FormatoData } from '../api/Central';
import Resultado from '../api/Resultado.js';
import Alert from '../components/Alert.js';
import Error from '../components/Error.js';
import Navegacao from '../components/Navegacao';

const Nota = (props) => {
  var item = props.nota;
  var lnk = "/notas/" + item.id;
  const pdf = () => {
    window.open(central.urlCentral + "/central/api/notas/" + item.id + "/visualizar", "_blank");
  }
  return (<React.Fragment>
    <tr>
      <td><a onClick={pdf}>{FormatoData.format(item.dataemissao)}</a></td>
      <td><a to={lnk}>{item.serie}</a></td>
      <td><a to={lnk}>{item.numero}</a></td>
    </tr>
  </React.Fragment>)
};

class Notas extends Component {

  constructor(props) {
    super(props);
    this.state = {
      notas: { rows: [] },
      disabled: false,
      erro: null,
      carregado: true
    }
  }

  redireciona() {
    this.props.history.push("/login");
  }

  carrega() {
    this.setState({ carregando: true });
    central.requestAndCatch(
      "GET",
      "/notas",
      null,
      (payload) => {
        var notas = new Resultado(payload);
        this.setState({ notas: notas, carregado: true });
      },
      (msg) => {
        this.setState({ erro: "Erro ao consultar notas: " + msg });
      },
      () => {
        this.setState({ carregando: false });
      });

  }

  componentDidMount() {
    this.carrega();
  }

  render() {
    var tabela = (<table>
      <thead>
        <tr>
          <th>Emissão</th>
          <th>Série</th>
          <th>Número</th>
        </tr>
      </thead>
      <tbody>
        {this.state.notas.rows.map((nota) => <Nota key={nota.id} nota={nota} />)}
      </tbody>
    </table>);

    var msgVazio;
    if (this.props.conta) {
      msgVazio = "Não existe nenhuma nota fiscal emitida para este tomador de serviço.";
    }

    var vazio = (<Alert type="info">{msgVazio}</Alert>);

    var erro = (<Error msg={this.state.erro} disabled={this.state.carregando} onButtonClick={this.carrega.bind(this)} buttonLabel="Tentar Novamente" />);

    var loader = (<Alert type="info">Carregando...</Alert>);


    var componente = null;
    if (this.state.carregando) {
      componente = loader;
    } else if (this.state.erro) {
      componente = erro;
    } else if (this.state.notas.rows.length > 0) {
      componente = tabela;
    } else if (this.props.conta) {
      componente = vazio;
    }

    return (
      <section className="container">
        <Navegacao link="/" titulo="Notas fiscais" />
        <section>
          {componente}
        </section>
      </section>
    );
  }
}


export default Notas;